export const environment = {
    seedFunctionApiUrl: 'https://func-seh-qa-uks-002-daavcnhuhphth7cm.uksouth-01.azurewebsites.net/api/{0}?code=HHG83Vv00oYmRIWc9xhsp8n92C1x4iRtkWF0pNmiK2rTAzFuSt1IDA==',
    sehApiUrl : 'https://app-seh-qa-uks-001.azurewebsites.net/api/',
    msalConfig: {
        auth: {
            clientId: 'f273590a-2504-4451-832a-f043b77add8d',
            authority: 'https://login.microsoftonline.com/01583be4-f096-49f4-bd19-56b649a8482f',
            redirectUri: 'https://qa.admin.seh.icshosting.net/auth',
        },
    },
    apiConfig: {
        scopes: ['api://7171a077-6907-4a14-bf33-2469a0dd218f/access_as_user'],
        uri: 'https://app-seh-qa-uks-001.azurewebsites.net/',
    }
};
